var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSouthKorea2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "South_Korea@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-578.000000, -1173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "South_Korea"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(508.000000, 1103.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 0.01,
    y: 0.1,
    width: 70,
    height: 47,
    rx: 6.64
  }), /*#__PURE__*/React.createElement("g", {
    id: "_000000ff",
    transform: "translate(10.000000, 4.000000)",
    fill: "#434A54"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0.39 10.36 6.9 0.6 8.53 1.68 2.02 11.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "41.08 1.68 42.71 0.6 45.71 5.07 44.08 6.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83,12 C4.99666667,8.74666667 7.16666667,5.49333333 9.34,2.24 L10.96,3.32 L4.45,13.08 L2.83,12 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.63,3.33 C39.16,2.94 39.72,2.6 40.26,2.23 C42.4266667,5.48333333 44.5966667,8.73666667 46.77,11.99 L45.14,13.07 C43,9.82 40.82,6.56 38.63,3.33 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "11.78 3.85 13.41 4.93 6.9 14.69 5.27 13.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.19,4.94 L37.82,3.86 L40.82,8.34 L39.2,9.42 C38.18,7.92 37.19,6.43 36.19,4.94 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6,7 C45.14,6.64 45.67,6.28 46.21,5.93 L49.21,10.38 L47.58,11.46 L44.6,7 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "39.72 10.22 41.35 9.14 44.35 13.61 42.72 14.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "5.27 25.55 6.9 24.47 13.41 34.23 11.78 35.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "42.7 24.46 44.33 25.54 41.33 30.01 39.7 28.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "2.83 27.17 4.46 26.09 7.46 30.56 5.83 31.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "45.14 26.09 46.77 27.17 43.77 31.64 42.14 30.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0.39 28.8 2.02 27.72 8.53 37.48 6.9 38.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.58,27.72 C48.13,28.07 48.67,28.44 49.21,28.8 L46.21,33.27 L44.58,32.18 L47.58,27.72 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "39.18 29.75 40.81 30.83 37.81 35.3 36.18 34.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36,32.47 L7.98,31.38 C8.98,32.86 9.98,34.38 10.98,35.85 L9.35,36.94 L6.36,32.47 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.63,35.85 C39.63,34.36 40.63,32.85 41.63,31.38 C42.17,31.75 42.72,32.1 43.25,32.47 L40.25,36.94 L38.63,35.85 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.05,33 C44.6,33.35 45.14,33.72 45.68,34.08 L42.68,38.55 L41.05,37.46 L44.05,33 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_cd2e3aff",
    transform: "translate(24.000000, 11.000000)",
    fill: "#EC5565"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.86,2.46 C8.4312138,0.360128998 12.8452527,0.299790106 16.4725309,2.30125939 C20.0998091,4.30272867 22.4023135,8.06913989 22.53,12.21 C22.6079181,14.5107738 22.0024395,16.7830581 20.79,18.74 C22.0723152,16.4909923 21.7298437,13.667467 19.9470476,11.7902333 C18.1642515,9.91299974 15.3621446,9.4253734 13.05,10.59 C12.1420305,11.0504057 11.3699256,11.7397851 10.81,12.59 C9.37065729,14.7581392 6.67558968,15.7197646 4.18886174,14.9524842 C1.70213381,14.1852039 0.0174518359,11.8722059 0.05,9.27 C0.0685326739,8.37973675 0.276479726,7.50363196 0.66,6.7 C1.66810062,4.94596304 3.11559707,3.4846809 4.86,2.46 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_0047a0ff",
    transform: "translate(23.000000, 17.000000)",
    fill: "#4658A9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.07,6.2 C0.12630289,4.25089643 0.676856205,2.34804653 1.67,0.67 C1.28647973,1.47363196 1.07853267,2.34973675 1.06,3.24 C1.02745184,5.84220591 2.71213381,8.15520386 5.19886174,8.92248423 C7.68558968,9.6897646 10.3806573,8.7281392 11.82,6.56 C13.2339518,4.46328095 15.8318262,3.5078293 18.2673546,4.18877853 C20.7028829,4.86972775 22.4285171,7.03398886 22.55,9.56 C22.6072781,10.6836988 22.3436844,11.8005036 21.79,12.78 C20.5459466,14.8145246 18.7060442,16.4170203 16.52,17.37 C12.8282873,18.9894222 8.56387052,18.6014509 5.22501674,16.3423966 C1.88616295,14.0833424 -0.0601117271,10.2691862 0.07,6.24 L0.07,6.2 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthKorea2X);
export default __webpack_public_path__ + "static/media/South_Korea@2x.d90ca6b7c593f3174bb00b5d704796b6.svg";
export { ForwardRef as ReactComponent };